import { call, put } from 'redux-saga/effects';
import UploadImageToGoalActions from '../redux/UploadImageToGoalRedux';
import { api } from './api';

export function* uploadimagetogoalsagas(action: any): Generator<any, void, any> {
  const { id, image } = action;
  const response = yield call(api.uploadImageToGoal, id, image);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(UploadImageToGoalActions.uploadImageToGoalSuccess(response.data));
  } else {
    yield put(UploadImageToGoalActions.uploadImageToGoalFailure());
  }
}